module.exports = __webpack_public_path__ + "static/media/Apple iPhone 8 Gold.a5f4c3bb.png";